import type { RouteObject } from 'react-router';

/** The tickets pages, loaded once on first use (the import is cached), so the sign-in pages stay small. */
const load = () => import('./pages');

/**
 * The tickets routes, open to every signed-in member (outside /settings, which only administrators and the help
 * desk open): /tickets (My tickets across organizations), /tickets/:orgId/new and /tickets/:orgId/:number (the link
 * every ticket email carries). platform-api decides what each person sees.
 */
export function ticketRoutes(): RouteObject[] {
  return [
    { path: 'tickets', lazy: async () => ({ Component: (await load()).MyTicketsPage }) },
    { path: 'tickets/:orgId/new', lazy: async () => ({ Component: (await load()).NewTicketPage }) },
    { path: 'tickets/:orgId/:number', lazy: async () => ({ Component: (await load()).TicketPage }) },
  ];
}
